import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

interface BounceInfo {
  has_bounce: boolean;
  bounce_type: 'hard' | 'soft' | 'complaint' | null;
  bounce_reason: string | null;
  bounced_at: string | null;
}

export const useEmailBounceStatus = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["email-bounce-status", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;

      const { data, error } = await supabase.rpc('get_user_bounce_info', {
        p_user_id: user.id
      });

      if (error) {
        console.error("Error fetching bounce status:", error);
        return null;
      }

      // The RPC returns an array, get the first result
      const bounceInfo = data?.[0] as BounceInfo | undefined;
      return bounceInfo || null;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
